import React, { Component, useEffect, useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import "./editpersondetailsform.css";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Reports from "./reports";
import Service from "../../Service/firebase";
import { Country, State, City } from "country-state-city";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";

// console.log(State.getAllStates().map((namex) => namex));
Country.getAllCountries().map((namex) => namex.name);
export const conditionLinks = (prop) => {
	if (prop === "patients") {
		return "/patientlist";
	} else if (prop === "doctors") {
		return "/doctorslist";
	} else if (prop === "nurses") {
		return "/nurselist";
	} else if (prop === "pharmacists") {
		return "/pharmacistslist";
	} else if (prop === "laboratorist") {
		return "/laboratoristlist";
	} else if (prop === "accountant") {
		return "/accountantlist";
	} else if (prop === "receptionist") {
		return "/receptionistlist";
	}
};
const EditPersonDetailsForm = (props) => {
	const [drugs, setDrugs] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [payments, setPayments] = useState([]);
	// console.log(props.personDetails.id);
	const firebaseData = async () => {
		const res = await Service.getDrugdetails(props.personDetails.id);
		if (res === "error") {
			console.log("Error in get person details data");
		} else {
			setDrugs(res);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		firebaseData();
	}, []);

	const paymentfn = (p) => {
		if (payments.includes(p)) {
			const modifiedPayments = payments.filter((payment) => payment !== p);
			setPayments(modifiedPayments);
		} else {
			const newPayments = [...payments, p];
			setPayments(newPayments);
		}
	};

	let count = 0;
	return (
		<div className="editd_person_details_formpage">
			<div className="container main_section">
				<div className="topheader">
					<ul>
						<li>
							<Link to={conditionLinks(props.personDetails.collectionName)}>
								<i
									className="fa fa-arrow-circle-o-right fa-2x"
									aria-hidden="true"
								></i>
							</Link>
						</li>
						<li>
							<h5>{props.personDetails.collectionName}</h5>
						</li>
					</ul>
				</div>
				<hr />
				{props.personDetails.collectionName === "patients" ? (
					<Accordion>
						<AccordionSummary
							// expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
						>
							<Typography>Patient Details</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<div className="row">
								<div className="col-sm-8 first_section">
									<form onSubmit={props.handleSubmit}>
										<div className="form-row">
											<div className="col-md-6 mb-3">
												<label htmlFor="validationDefault01">First name</label>
												<input
													name="firstname"
													type="text"
													className="form-control"
													id="validationDefault01"
													required
													value={props.personDetails.firstname}
													onChange={props.onEdit}
												/>
											</div>
											<div className="col-md-6 mb-3">
												<label htmlFor="validationDefault02">Last name</label>
												<input
													name="lastname"
													type="text"
													className="form-control"
													id="validationDefault02"
													value={props.personDetails.lastname}
													onChange={props.onEdit}
													required
												/>
											</div>
										</div>

										<div className="form-row">
											<div className="col-md-6 mb-3">
												<label htmlFor="validationDefault10">Sex</label>
												<select
													name="sex"
													className="custom-select"
													id="validationDefault10"
													value={props.personDetails.sex}
													onChange={props.onEdit}
													required
												>
													<option></option>
													<option>Male</option>
													<option>Female</option>
													<option>other</option>
												</select>
											</div>
											<div className="col-md-6 mb-3">
												<label htmlFor="validationDefault11">Age</label>
												<input
													name="age"
													type="number"
													className="form-control"
													id="validationDefault11"
													value={props.personDetails.age}
													onChange={props.onEdit}
												/>
											</div>
										</div>

										<div className="form-row">
											<div className="col-md-6 mb-3">
												<label htmlFor="validationDefault12">Birth Date</label>

												<MuiPickersUtilsProvider utils={DateFnsUtils}>
													<DatePicker
														style={{
															padding: "0px 10px",
															border: "1px solid rgb(197, 197, 197)",
														}}
														name="birthdate"
														className="  form-control"
														// selected={props.startDate}
														InputProps={{
															disableUnderline: true,
														}}
														value={props.date}
														onChange={props.handleChange}
														autoComplete="off"
														format="MM/dd/yyyy"
													/>
												</MuiPickersUtilsProvider>
											</div>
											<div className="col-md-6 mb-3">
												<label htmlFor="validationDefault13">Blood Group</label>
												<select
													name="bloodgroup"
													type="text"
													className="form-control"
													id="bloodgroup"
													value={props.personDetails.bloodgroup}
													onChange={props.onEdit}
												>
													<option></option>
													<option>A+</option>
													<option>A-</option>
													<option>AB+</option>
													<option>AB-</option>
													<option>B+</option>
													<option>B-</option>
													<option>O+</option>
													<option>O-</option>
												</select>
											</div>
										</div>

										<div className="form-row">
											<div className="col-md-12 mb-3">
												<label htmlFor="validationDefault03">Mobile</label>
												<input
													name="phonenumber"
													type="number"
													className="form-control"
													id="validationDefault03"
													value={props.personDetails.phonenumber}
													onChange={props.onEdit}
												/>
											</div>
										</div>
										<div className="form-row">
											<div className="col-md-12 mb-3">
												<label htmlFor="validationDefault04">Email</label>
												<input
													type="email"
													name="email"
													className="form-control"
													id="validationDefault04"
													value={props.personDetails.email}
													onChange={props.onEdit}
												/>
											</div>
										</div>
										<div className="form-row">
											<div className="col-md-12 mb-3">
												<label htmlFor="validationDefault05">Address</label>
												<input
													name="address"
													type="text"
													className="form-control"
													id="validationDefault05"
													value={props.personDetails.address}
													onChange={props.onEdit}
												/>
											</div>
										</div>
										<div className="form-row">
											<div className="col-md-6 mb-3">
												<label htmlFor="validationDefault06">City</label>
												<input
													name="city"
													type="text"
													className="form-control"
													id="validationDefault06"
													value={props.personDetails.city}
													onChange={props.onEdit}
												/>
											</div>
											<div className="col-md-3 mb-3">
												<label htmlFor="validationDefault07">State</label>
												<select
													name="state"
													className="custom-select"
													id="validationDefault07"
													value={props.personDetails.state}
													onChange={props.onEdit}
												>
													{Country.getAllCountries().map((namex) => (
														<option>{namex.name}</option>
													))}
												</select>
											</div>
											<div className="col-md-3 mb-3">
												<label htmlFor="validationDefault08">Zip</label>
												<input
													name="zip"
													type="text"
													className="form-control"
													id="validationDefault85"
													value={props.personDetails.zip}
													onChange={props.onEdit}
												/>
											</div>
										</div>
										<h5>Next of kin</h5>
										<hr />
										<div className="form-row">
											<div className="col-md-12 mb-3">
												<label htmlFor="validationDefault04">Next of kin</label>
												<input
													type="text"
													name="Nextofkin"
													className="form-control"
													id="Nextofkin"
													value={props.personDetails.Nextofkin}
													onChange={props.onEdit}
												/>
											</div>
										</div>
										<div className="form-row">
											<div className="col-md-12 mb-3">
												<label htmlFor="validationDefault04">
													Next of kin email
												</label>
												<input
													type="text"
													name="Nextofkinemail"
													className="form-control"
													id="Nextofkinemail"
													value={props.personDetails.Nextofkinemail}
													onChange={props.onEdit}
												/>
											</div>
										</div>
										<div className="form-row">
											<div className="col-md-12 mb-3">
												<label htmlFor="validationDefault04">
													Next of kin address
												</label>
												<input
													type="text"
													name="Nextofkinaddress"
													className="form-control"
													id="Nextofkinaddress"
													value={props.personDetails.Nextofkinaddress}
													onChange={props.onEdit}
												/>
											</div>
										</div>

										<div className="form-group">
											<label htmlFor="validationDefault09">Remarks</label>
											<textarea
												name="remarks"
												className="form-control"
												id="validationDefault09"
												rows="3"
												value={props.personDetails.remarks}
												onChange={(e) => {
													props.onEdit(e);
												}}
											></textarea>
										</div>

										<button
											className="btn btn-success bg-edit update_btn"
											type="submit"
										>
											Update
										</button>
									</form>
								</div>
								<div className="col-sm-4 second_section">
									<div className="profileimage">{props.profileHtmlelEment}</div>
									<div className="btn_section">
										<label htmlFor="files" className="selectimage">
											Upload Image
										</label>
										<input
											name="avatarimage"
											id="files"
											type="file"
											onChange={props.onImageChange}
										/>
										<button
											type="button"
											className="removebutton"
											onClick={props.onImageRemove}
										>
											{" "}
											Remove
										</button>
									</div>

									<input
										id="files"
										type="file"
										onChange={props.onImageChange}
									/>
								</div>
							</div>
						</AccordionDetails>
					</Accordion>
				) : (
					<div className="row">
						<div className="col-sm-8 first_section">
							<form onSubmit={props.handleSubmit}>
								<div className="form-row">
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault01">First name</label>
										<input
											name="firstname"
											type="text"
											className="form-control"
											id="validationDefault01"
											required
											value={props.personDetails.firstname}
											onChange={props.onEdit}
										/>
									</div>
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault02">Last name</label>
										<input
											name="lastname"
											type="text"
											className="form-control"
											id="validationDefault02"
											value={props.personDetails.lastname}
											onChange={props.onEdit}
											required
										/>
									</div>
								</div>

								<div className="form-row">
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault10">Sex</label>
										<select
											name="sex"
											className="custom-select"
											id="validationDefault10"
											value={props.personDetails.sex}
											onChange={props.onEdit}
											required
										>
											<option></option>
											<option>Male</option>
											<option>Female</option>
											<option>other</option>
										</select>
									</div>
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault11">Age</label>
										<input
											name="age"
											type="number"
											className="form-control"
											id="validationDefault11"
											value={props.personDetails.age}
											onChange={props.onEdit}
										/>
									</div>
								</div>

								<div className="form-row">
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault12">Birth Date</label>

										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<DatePicker
												style={{
													padding: "0px 10px",
													border: "1px solid rgb(197, 197, 197)",
												}}
												name="birthdate"
												className="  form-control"
												// selected={props.startDate}
												InputProps={{
													disableUnderline: true,
												}}
												value={props.date}
												onChange={props.handleChange}
												autoComplete="off"
												format="MM/dd/yyyy"
											/>
										</MuiPickersUtilsProvider>
									</div>
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault13">Blood Group</label>
										<select
											name="bloodgroup"
											type="text"
											className="form-control"
											id="bloodgroup"
											value={props.personDetails.bloodgroup}
											onChange={props.onEdit}
										>
											<option></option>
											<option>A+</option>
											<option>A-</option>
											<option>AB+</option>
											<option>AB-</option>
											<option>B+</option>
											<option>B-</option>
											<option>O+</option>
											<option>O-</option>
										</select>
									</div>
								</div>

								<div className="form-row">
									<div className="col-md-12 mb-3">
										<label htmlFor="validationDefault03">Mobile</label>
										<input
											name="phonenumber"
											type="number"
											className="form-control"
											id="validationDefault03"
											value={props.personDetails.phonenumber}
											onChange={props.onEdit}
										/>
									</div>
								</div>
								<div className="form-row">
									<div className="col-md-12 mb-3">
										<label htmlFor="validationDefault04">Email</label>
										<input
											type="email"
											name="email"
											className="form-control"
											id="validationDefault04"
											value={props.personDetails.email}
											onChange={props.onEdit}
										/>
									</div>
								</div>
								<div className="form-row">
									<div className="col-md-12 mb-3">
										<label htmlFor="validationDefault05">Address</label>
										<input
											name="address"
											type="text"
											className="form-control"
											id="validationDefault05"
											value={props.personDetails.address}
											onChange={props.onEdit}
										/>
									</div>
								</div>
								<div className="form-row">
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault06">City</label>
										<input
											name="city"
											type="text"
											className="form-control"
											id="validationDefault06"
											value={props.personDetails.city}
											onChange={props.onEdit}
										/>
									</div>
									<div className="col-md-3 mb-3">
										<label htmlFor="validationDefault07">State</label>
										<select
											name="state"
											className="custom-select"
											id="validationDefault07"
											value={props.personDetails.state}
											onChange={props.onEdit}
										>
											{Country.getAllCountries().map((namex) => (
												<option>{namex.name}</option>
											))}
										</select>
									</div>
									<div className="col-md-3 mb-3">
										<label htmlFor="validationDefault08">Zip</label>
										<input
											name="zip"
											type="text"
											className="form-control"
											id="validationDefault85"
											value={props.personDetails.zip}
											onChange={props.onEdit}
										/>
									</div>
								</div>
								<h5>Next of kin</h5>
								<hr />
								<div className="form-row">
									<div className="col-md-12 mb-3">
										<label htmlFor="validationDefault04">Next of kin</label>
										<input
											type="text"
											name="Nextofkin"
											className="form-control"
											id="Nextofkin"
											value={props.personDetails.Nextofkin}
											onChange={props.onEdit}
										/>
									</div>
								</div>
								<div className="form-row">
									<div className="col-md-12 mb-3">
										<label htmlFor="validationDefault04">
											Next of kin email
										</label>
										<input
											type="text"
											name="Nextofkinemail"
											className="form-control"
											id="Nextofkinemail"
											value={props.personDetails.Nextofkinemail}
											onChange={props.onEdit}
										/>
									</div>
								</div>
								<div className="form-row">
									<div className="col-md-12 mb-3">
										<label htmlFor="validationDefault04">
											Next of kin address
										</label>
										<input
											type="text"
											name="Nextofkinaddress"
											className="form-control"
											id="Nextofkinaddress"
											value={props.personDetails.Nextofkinaddress}
											onChange={props.onEdit}
										/>
									</div>
								</div>

								<div className="form-group">
									<label htmlFor="validationDefault09">Remarks</label>
									<textarea
										name="remarks"
										className="form-control"
										id="validationDefault09"
										rows="3"
										value={props.personDetails.remarks}
										onChange={(e) => {
											props.onEdit(e);
										}}
									></textarea>
								</div>

								<button
									className="btn btn-success bg-edit update_btn"
									type="submit"
								>
									Update
								</button>
							</form>
						</div>
						<div className="col-sm-4 second_section">
							<div className="profileimage">{props.profileHtmlelEment}</div>
							<div className="btn_section">
								<label htmlFor="files" className="selectimage">
									Upload Image
								</label>
								<input
									name="avatarimage"
									id="files"
									type="file"
									onChange={props.onImageChange}
								/>
								<button
									type="button"
									className="removebutton"
									onClick={props.onImageRemove}
								>
									{" "}
									Remove
								</button>
							</div>

							<input id="files" type="file" onChange={props.onImageChange} />
						</div>
					</div>
				)}

				{props.personDetails.collectionName === "patients" ? (
					<>
						<table className="table table-striped">
							<thead className="thead tablehead">
								<tr>
									<th scope="col">#</th>

									{/* <th scope="col">Email</th> */}
									<th scope="col">Test to be done</th>
									<th scope="col">Date</th>
									<th scope="col">Time</th>
									<th scope="col">Payment</th>
								</tr>
							</thead>
							{isLoading ? (
								<i className="fas fa-spinner fa-pulse fa-2x "></i>
							) : drugs.length === 0 ? (
								<tbody>
									<tr>
										<td>No Info</td>
									</tr>
								</tbody>
							) : (
								<tbody className="tablebody">
									{drugs &&
										drugs.map((p, index) => {
											count++;
											let date = new Date(p.createdAt.toDate());
											const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
											const createdDate = `${date.getDate()}/${
												date.getMonth() + 1
											}/${date.getFullYear()}`;

											return (
												<tr key={index}>
													<td className="align-middle">{count}</td>

													<td className="align-middle">{p.note}</td>
													<td className="align-middle">
														{createdDate === "" ? "N/A" : createdDate}
													</td>
													<td className="align-middle">
														{createdTime === "" ? "N/A" : createdTime}
													</td>
													<td className="align-middle">
														<button
															onClick={() => paymentfn(index)}
															className={
																payments.includes(index)
																	? `bg-edit p-2 rounded-lg`
																	: `bg-add p-2 rounded-lg`
															}
														>
															{payments.includes(index) ? "Paid" : "Not Paid"}
														</button>
													</td>
												</tr>
											);
										})}
								</tbody>
							)}
						</table>
						<div className="thrid_section">
							<Reports personDetails={props.personDetails}></Reports>
						</div>
					</>
				) : null}
			</div>
		</div>
	);
};

export default EditPersonDetailsForm;
